import React, { FC } from "react";
import classes from "./MediaSubTitle.module.css";

type MediaSubTitleProps = {
  title: string;
  length: number;
  type?: "review" | "cast" | "images" | "videos";
  openReviewModal?: () => void;
  updateRight?: () => void;
  updateLeft?: () => void;
};

const MediaSubTitle: FC<MediaSubTitleProps> = ({
  title,
  length,
  type,
  openReviewModal,
  updateRight,
  updateLeft,
}) => {
  return (
    <div className={classes.category_title_container}>
      <div className={classes.title_container}>
        <p className={classes.category_title}>{title}</p>
        <p className={classes.images_length}>{length}</p>
        <i className={`pi pi-chevron-right ${classes.chevron}`} />
      </div>
      {type === "review" && (
        <button className={classes.add_review_btn} onClick={openReviewModal}>
          <i className={`pi pi-plus ${classes.add_icon}`} />
          Add a Review
        </button>
      )}
      {type === "videos" && (
        <div className={classes.buttons}>
          <button className={classes.prevBtn} onClick={updateRight}>
            <i className={`pi pi-chevron-left ${classes.left_icon}`} />
          </button>
          <button className={classes.nextBtn} onClick={updateLeft}>
            <i className={`pi pi-chevron-right ${classes.right_icon}`} />
          </button>
        </div>
      )}
    </div>
  );
};

export default MediaSubTitle;
